module.exports = __webpack_public_path__ + "media/components/Sponsors/FormTags/Categories/25-17d69aa18d0a1543e01bc2fe1ca48e88.png";